import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const Showimage = ({
 
  isOpen,
  header,
  onCancel,

  message,
  list,
 size ="xl"
}) => {

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader> 
        </ModalHeader>
        <ModalBody>

          { list &&      <div className="mytooltip tooltip-effect-1">
                            <span className="tooltip-item">
                              <span className="col-auto  p-0 ms-1 mb-3" >

                                <img
                                  className="img-fluid"
                                  src={list}
                                  alt=""
                                  // style={{
                                  //   maxHeight: 650,
                                  //   Width: 650,
                                  // }}
                                />
                              </span>
                            </span>

                            {/* <span className="tooltip-content clearfix">
                              <img
                                className="personTooltip"
                                src={list}
                                alt=""
                                style={{
                                  width: "100%",
                                  minHeight: "400px",
                                  minWidth: "450px",
                                }}
                              />

                              <span className="tooltip-text"></span>
                            </span> */}
                          </div>}
         

          {!list && message}
        </ModalBody>
       

        
        <ModalFooter>
      
    
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Showimage;
